import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import * as IssuesV2Store from '../../../redux/issuesV2';
import { getSavedFiltersPermissions } from '../../../helpers/savedFilters';
import type { SavedFiltersPermission } from '../../../helpers/savedFilters';

/**
 * Hook for determining if the user has permission to edit the saved filters,
 * depending on the category. Auto-updates whenever category change.
 */
const useSavedFiltersPermissions = (): SavedFiltersPermission => {
  const category = useSelector(IssuesV2Store.selectors.getIssueCategory);
  return useMemo(() => getSavedFiltersPermissions(category), [category]);
};

//  For convenience when importing this hook.
export type { SavedFiltersPermission };

export default useSavedFiltersPermissions;
